import { AdType } from '../../constants/ads';
import AdUnit, { IPresetAdUnitProps } from './AdUnit';

const RightRailAdUnit: React.FC<IPresetAdUnitProps> = props => {
  const isInc = typeof props.incIndex !== 'undefined';

  const adCode = isInc ? AdType.DesktopMPUInc : AdType.DesktopMPUPlusTop;

  return <AdUnit code={adCode} holdWidth {...props} />;
};

export default RightRailAdUnit;
